import { render } from "./Edit-Solicitud-Aceptada.vue?vue&type=template&id=b589279c&scoped=true"
import script from "./Edit-Solicitud-Aceptada.vue?vue&type=script&lang=js"
export * from "./Edit-Solicitud-Aceptada.vue?vue&type=script&lang=js"

import "./Edit-Solicitud-Aceptada.vue?vue&type=style&index=0&id=b589279c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b589279c"]])

export default __exports__